import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CheckoutForm from "./components/CheckoutForm";
import PaymentCallback from "./components/PaymentCallback";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CheckoutForm />} />
        <Route path="/payment/callback" element={<PaymentCallback />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
